/* eslint-disable @typescript-eslint/no-explicit-any */
import { forwardRef, useCallback, useImperativeHandle, useRef, useState, Ref, RefObject } from 'react';
import { Dialog, DialogBody, DialogContent, DialogSurface, DialogTitle, makeStyles, tokens } from '@fluentui/react-components';
import { Dismiss16Filled } from '@fluentui/react-icons';
import TemplateItem from './template-item';
import { templates } from './templates';

interface TemplateDialogRef {
	open: () => void;
	close: () => void;
}

export const useTemplateDialogRef = () => {
	const ref: RefObject<TemplateDialogRef> = useRef(null);
	return ref;
};

function TemplatesDialogRef(
	_: any,
	ref: Ref<TemplateDialogRef>
) {
	const classes = useStyles();
	const [open, setOpen] = useState(false);

	const openTemplatesDialogHandler = useCallback((value: boolean) => {
		setOpen(value);
	}, []);

	useImperativeHandle(ref, () => ({
		open: () => {
			setOpen(true);
		},
		close: () => {
			setOpen(false);
		},
	}));
  
	return (
		<Dialog
			open={open}
			onOpenChange={(_, data) => {
				openTemplatesDialogHandler(data.open);
			}}
		>
			<DialogSurface style={{ width: '90vw', maxWidth: '1000px'}}>
				<div className={classes.closeButtonContainer}>
					<button className={classes.closeButton} onClick={() => setOpen(false)}>
						<Dismiss16Filled />
					</button>
				</div>
				<DialogBody>
					<DialogTitle className={classes.title}>
            Create rule with a template
					</DialogTitle>
					<DialogContent>
						<div className={classes.templatesContainer}>
							{templates.map((template) => (
								<TemplateItem
									key={template.id}
									id={template.id}
									title={template.title}
								/>
							))}
						</div>
					</DialogContent>
				</DialogBody>
			</DialogSurface>
		</Dialog>
	);
}

const useStyles = makeStyles({
	title: {
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase600,
		fontWeight: tokens.fontWeightSemibold,
		lineHeight: tokens.lineHeightBase300,
		color: tokens.colorNeutralForeground1,
		paddingBottom: '16px'
	},
	templatesContainer: {
		display: 'grid',
		gridTemplateColumns: 'repeat(3, 1fr)',
		gap: '16px',
	},
	closeButtonContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		position: 'relative',
	},
	closeButton: {
		position: 'absolute',
		top: '0',
		right: '0',
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		fontSize: tokens.fontSizeBase300,
		fontWeight: tokens.fontWeightRegular,
		lineHeight: tokens.lineHeightBase300,
		color: tokens.colorNeutralForeground1,
	},
});

const TemplatesDialog = forwardRef<TemplateDialogRef, any>(TemplatesDialogRef);
export default TemplatesDialog;